import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { If } from '../if'

export const InfiniteScroll = ({
  children,
  currentPage,
  loadNextPage,
  isLastPage,
}) => {
  const ref = useRef()
  useEffect(() => {
    const handleScroll = () => {
      const element = ref.current
      if (element) {
        const rect = element.getBoundingClientRect()
        const isVisible = rect.top <= window.innerHeight && rect.bottom >= 0
        if (isVisible) {
          loadNextPage()
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [ref, currentPage])

  return (
    <div>
      {children}
      <If condition={!isLastPage} render={() => <span ref={ref} />} />
    </div>
  )
}

InfiniteScroll.defaultProps = {
  children: <></>,
  currentPage: 0,
  isLastPage: false,
  loadNextPage: () => null,
}

InfiniteScroll.propTypes = {
  children: PropTypes.node.isRequired,
  currentPage: PropTypes.number,
  isLastPage: PropTypes.bool,
  loadNextPage: PropTypes.func,
}
